
import axios from 'axios'
import qs from 'qs'
import Toast from 'vux/src/components/toast/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'

import Fetch from './fetchTool'


export default {

get (url,params) {
return new Promise((resolve,reject) => {
axios({
method: 'get',
url,
params: qs.stringify(params),
cancelToken: new CancelToken(c => {
cancel = c
})
}).then(res => {
resolve(res)
})
})
},

async post (url,params,showLoading=true,hideLoading=true,timeout) {
params.params = JSON.parse(params.params)
if(showLoading){
return Fetch.post(url,params).then(res=>{
return res
}).catch(err=>{
console.error('请求失败URL：' + url);
return err
})
}else{
return Fetch.postSimpleness(url,params).then(res=>{
return res
}).catch(err=>{
console.error('请求失败URL：' + url);
return err
})
}
}

}


// WEBPACK FOOTER //
// ./src/common/tool/HttpUtil.js